/**
 * compile and export all form components from one file
 */

import ArrayEditor from './ArrayEditor.jsx';
import CheckboxInput from './CheckboxInput.jsx';
import EmailInput from './EmailInput.jsx';
// react-files package is finally at v3, maybe we can use it in the future: https://github.com/mother/react-files/releases/tag/v3.0.0
// native solution for now with a Yote style wrapper
import FileInput from './FileInput.jsx';
import ListComparator from './ListComparator.jsx';
import NewPasswordInput from './NewPasswordInput.jsx';
import NumberInput from './NumberInput.jsx';
import PasswordInput from './PasswordInput.jsx';
import RadioInput from './RadioInput.jsx';
import SearchInput from './SearchInput.jsx';
import SelectInput from './SelectInput.jsx';
import SliderInput from './SliderInput.jsx';
import TextAreaInput from './TextAreaInput.jsx';
import TextInput from './TextInput.jsx';
// import UrlInput from './UrlInput.jsx';

export { ArrayEditor };
export { CheckboxInput };
export { EmailInput };
export { FileInput };
export { ListComparator };
export { NewPasswordInput };
export { NumberInput };
export { PasswordInput };
export { RadioInput };
export { SearchInput };
export { SelectInput };
export { SliderInput };
export { TextAreaInput };
export { TextInput };
// export { UrlInput };
